import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { AuthSliceState } from '../../models/user';

export const initialState: AuthSliceState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  message: null,
};

export const authReducer = createReducer(
  initialState,

  // LOGIN
  on(AuthActions.login, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.loginSuccess, (state, { user, token }) => ({
    ...state,
    user,
    token,
    loading: false,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // UPDATE TOKEN
  on(AuthActions.updateAccessToken, (state, { token }) => ({
    ...state,
    token,
  })),

  // REGISTER
  on(AuthActions.register, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.registerSuccess, (state, { user }) => ({ ...state, user, loading: false })),
  on(AuthActions.registerFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // FORGOT PASSWORD
  on(AuthActions.forgotPassword, (state) => ({
    ...state,
    loading: true,
    error: null,
    message: null,
  })),
  on(AuthActions.forgotPasswordSuccess, (state, { message }) => ({
    ...state,
    loading: false,
    message,
  })),
  on(AuthActions.forgotPasswordFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // RESET PASSWORD
  on(AuthActions.resetPassword, (state) => ({
    ...state,
    loading: true,
    error: null,
    message: null,
  })),
  on(AuthActions.resetPasswordSuccess, (state, { message }) => ({
    ...state,
    loading: false,
    message,
  })),
  on(AuthActions.resetPasswordFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // VERIFY OTP
  on(AuthActions.verifyOtp, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.verifyOtpSuccess, (state, { user }) => ({ ...state, user, loading: false })),
  on(AuthActions.verifyOtpFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // LOGOUT
  on(AuthActions.logout, (state) => ({ ...state, user: null, message: null }))
);
